export interface DataWrapper<T> {
    data: T[];
}